import { customElement, property } from 'lit/decorators.js'
import { CSSResultGroup, html, LitElement, nothing } from 'lit'

import { style } from './popup.style.js'
import { targetStyle } from 'components/discovery/widgets/image-hotspot/image-hotspot.style.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


initializeIconsByRole({
  'csc-image-hotspot-popup.button-arrow': { name: 'arrow-right', style: 'light' },
})

export class ImageHotspotTargetClickedEvent extends Event {
  static type = 'image-hotspot-target-clicked' as const
  popupId: string

  constructor(popupId: string) {
    super(ImageHotspotTargetClickedEvent.type, { bubbles: true, composed: true })
    this.popupId = popupId
  }
}

@customElement('csc-image-hotspot-popup')
export class CSCImageHotspotPopup extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style, targetStyle]

  @property({ type: String })
  name = ''

  @property({ type: String })
  image = ''

  @property({ type: String })
  url = ''

  @property({ type: Number })
  x = 0

  @property({ type: Number })
  y = 0

  @property({ type: String, attribute: 'popup-id' })
  popupId = ''

  @property({ type: Boolean })
  active = false

  private triggerClick = (event: MouseEvent) => {
    event.stopPropagation()
    super.dispatchEvent(new ImageHotspotTargetClickedEvent(this.popupId))
  }

  override render() {
    return html`
      <cse-popup
        distance="20"
        ?active="${this.active}"
        class="csc-image-hotspot-popup"
        auto-position
      >
        <cse-hotspot-target
          slot="anchor"
          class="target"
          style="top: ${this.y}%; left: ${this.x}%;"
          @click="${(event: MouseEvent) => this.triggerClick(event)}"
        ></cse-hotspot-target>
        <cse-paper variant="primary">
          ${this.image ? html`
            <cse-image
              source="${this.image}"
              alt="${this.name}"
              width="230"
              height="100"
              fit="cover"
            ></cse-image>
          ` : nothing}
          <div class="text-wrapper">
            <cse-text variant="heading-5">${this.name}</cse-text>
            <cse-button
              variant="primary"
              size="small"
              url="${this.url}"
            >
              <cse-icon icon-role="csc-image-hotspot-popup.button-arrow"></cse-icon>
            </cse-button>
          </div>
        </cse-paper>
      </cse-popup>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-image-hotspot-popup': CSCImageHotspotPopup,
  }
}
